import React from "react";
import './vehicles.css'
import VehCard from "./VehCard";
import { VehicleInformation } from "../data/VehInfo";

const VarList = ({ vehKey, onVariantSelect }) => {

    const variants = VehicleInformation().platforms[vehKey].variants;  


    const handleChange = () => {

    }

    const handleSubmit = () => {
        
    }

    const content = Object.keys(variants).map((varKey, j)=>{
        return(
            <VehCard key={j} enabled={variants[varKey].enable} bgImg={variants[varKey].image} id={varKey} onClick={onVariantSelect}/>
        )
    })

    return (
        <div className="variant-list">
            <div className="variant-list-scrollable">
                {content}
            </div>
        </div>
    );
};

export default VarList;
